"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactScan = void 0;
var _react = require("react");
const useReactScan = ({
  enabled = false,
  environment
} = {}) => (0, _react.useEffect)(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlEnabled = urlParams.has('scan') && environment !== 'live';

  // Only run in development or when URL scan is enabled
  if (process.env.NODE_ENV === 'production' && !urlEnabled) {
    return;
  }
  if (enabled || urlEnabled) {
    void import('react-scan').then(({
      scan
    }) => {
      scan({
        enabled: true,
        dangerouslyForceRunInProduction: urlEnabled
      });
    });
  }
}, [enabled, environment]);
exports.useReactScan = useReactScan;
